const defaultProps = {
	value: false,
};

export default defaultProps;
